var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "bg-white flex justify-center items-center absolute inset-0",
    },
    [_c("GrmLoadingCircle")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }